import React, {useEffect} from "react";
import track, {setPageTitle} from "./utility";
import {Content, Container} from "./elements/layout";
import {ErrorNotification} from "@cb/apricot-react";
import $ from "classnames";
import "./Error.css";
import {useLocation} from "react-router-dom";
import WebConstant from "./WebConstant";

const Error = () => {
    const location = useLocation();
    const mismatchType = location.state?.mismatchType || "idpMismatchEcl";
    const destinationUrl = location.state?.destinationUrl || WebConstant.defaultStdDurl;
    //console.log(`-------mismatchType=${mismatchType}-------`);

    const [countdown, setCountdown] = React.useState(15);

    // Determine message and redirectUrl based on mismatchType
    let message = "for professionals only.";
    let redirectUrl = WebConstant.defaultStdDurl;
    if (mismatchType === "idpMismatchEpl") {
        message = "for students only.";
        redirectUrl = WebConstant.defaultProfDurl;
    }

    useEffect(() => {
        setPageTitle("Error");
        //track("500errorpage", appId);

        if (countdown === 0) {
            window.location.href = destinationUrl;
            return;
        }
        const timer = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);
        return () => clearTimeout(timer);
    }, [countdown]);

    return (
        <Container pageName="iam-error">
            <ErrorNotification title="Sorry! Insufficient Access." style={{borderRadius: "8px"}}>
                You are attempting to access a page that is designed <br/>
                {message}<br/><br/>
                <p>Redirecting in {countdown} seconds...</p>

            </ErrorNotification>
        </Container>
    );
};

export default Error;
